module.exports = __webpack_public_path__ + "img/bg-d@2x.487f3077.png";